
interface ProcessStatus {
    id: number;
    name: string;
  }
  
  interface ReceivingBatchCollectors {
    id: string;
    fileName: string;
    date: Date;
    collectorCode: string;
    userName: string;
    entityId: string;
    collectorFee: string;
    ProcessStatus: ProcessStatus;
    quantityLines: number;
    legalEntityDescription: string;
    valueTotal: number;
    batchId: string;
  }
  
  interface CollectionType {
    id: number;
    name: string;
  }
  
  interface BillingStatus {
    id: number;
    name: string;
  }
  
  interface PaymentStatus {
    id: number;
    name: string;
  }
  
  interface StatusBillet {
    Billing: BillingStatus;
    Payment: PaymentStatus;
  }
  
  interface Installment {
    id: string;
    controlNegotiationId: string;
    value: number;
    Type: CollectionType;
    accountsReceivableTypeId: string;
  }
  
  interface InterestRate {
    percent: number;
    value: number;
    interestValue: number;
  }
  
  interface LateFees {
    percent: number;
    value: number;
  }

  interface Honorario {
    percent: number;
    value: number;
  }
  
  interface Taxes {
    InterestRate: InterestRate;
    LateFees: LateFees;
    Honorario: Honorario;
  }
  
  interface DataReceiving {
    billetId: string;
    billetNumber: string;
    dueDate: Date;
    "delay days": number;
    CollectionType: CollectionType;
    contractId: string;
    StatusBillet: StatusBillet;
    InstallmentPlanning: Installment[];
    Taxes: Taxes;
  }
  
  interface Errors {
    type: string;
    description: string[];
  }
  
  interface DataFile {
    creditDate: Date;
    numberLine: number;
    billetSequential: number;
    billetValue: number;
    interestValue: number;
    lateFeesValue: number;
    honorarioValue: number;
    collectorFeeValue: number;
    paidValue: number;
    beneficiaryName: string;
    Errors: Errors;
  }
  
  interface ReceivingLineCollectors {
    id: string;
    receivingBatchCollectorId: string;
    LineStatus: ProcessStatus;
    DataReceiving: DataReceiving[];
    DataFile: DataFile;
  }
  
  export const mockReceivingBatchCollectors: ReceivingBatchCollectors[] = [
    {
      id: "774AF07A-BB0C-4ECE-A01E-DDFD359070B7",
      fileName: "COB_121-0001.RET",
      date: new Date("2025-01-15T06:00:00.000Z"),
      collectorCode: "121",
      userName: "maria.silva@adventistas.org",
      entityId: "8C23122D-954A-4003-A0D9-ED9B22896144",
      collectorFee: "S",
      ProcessStatus: { id: 3, name: "StandBy" },
      quantityLines: 2,
      legalEntityDescription: "Instituto Adventista Paranaense",
      valueTotal: 1351.8,
      batchId: "7EA430FE-3FDF-4145-969D-114D4039F092",
    }, 
    {
        id: "F0B8D5B2-E1F7-40AD-A433-364520DB73F0",
        fileName: "COB_121-0002.RET",
        date: new Date("2025-01-16T06:00:00.000Z"),
        collectorCode: "122",
        userName: "isabel.barja",
        entityId: "8C23122D-954A-4003-A0D9-ED9B22896144",
        collectorFee: "S",
        ProcessStatus: { id: 1, name: "Processing" },
        quantityLines: 1,
        legalEntityDescription: "Instituto Adventista Paranaense",
        valueTotal: 1500.5,
        batchId: "CF6BB0D9-4115-4954-8BDA-0000AB81128F",
      },
  ];
  
  export const mockReceivingLineCollectors: ReceivingLineCollectors[] = [
    {
      id: "830E0000-A495-401E-ADAE-AE2400C26B63",
      receivingBatchCollectorId: "774AF07A-BB0C-4ECE-A01E-DDFD359070B7",
      LineStatus: { id: 0, name: "pendency" },
      DataReceiving: [
        {
          billetId: "AFF979F2-5B35-4F6E-A18D-BBD0AD0C4B21",
          billetNumber: "1010201.0041276",
          dueDate: new Date("2021-11-20T06:00:00.000Z"),
          "delay days": 1152,
          CollectionType: { id: 1, name: "Billet" },
          contractId: "2B38199A-FF5A-4BBC-95E0-6FC378A676BD",
          StatusBillet: {
            Billing: { id: 0, name: "Active" },
            Payment: { id: 0, name: "NotPaid" },
          },
          InstallmentPlanning: [
            {
              id: "EE19A606-C12F-4E05-BB43-50D7F41C2F70",
              controlNegotiationId: "CA27EA92-8219-426A-B69C-08CA38603273",
              value: 243.38,
              Type: { id: 0, name: "Normal" },
              accountsReceivableTypeId: "1F5E4F00-57DD-4F5E-839A-2FC77960465C",
            },
          ],
          Taxes: {
            InterestRate: { percent: 1.0, value: 0.08, interestValue: 92.16 },
            LateFees: { percent: 2.0, value: 4.87 },
            Honorario: { percent: 2, value: 20 },
          },
        },
      ],
      DataFile: {
        creditDate: new Date("2022-01-20T06:00:00.000Z"),
        numberLine: 1,
        billetSequential: 1236545,
        billetValue: 243.38,
        interestValue: 92.16,
        lateFeesValue: 4.87,
        honorarioValue: 20,
        collectorFeeValue: 24.38,        
        paidValue: 364.79,
        beneficiaryName: "Isabel Barja",
        Errors: { type: "None", description: [] },
      },
    },
    // {
    //   id: "5D2F1E00-BB8F-4B59-8A0E-5AAB478F9B12",
    //   receivingBatchCollectorId: "774AF07A-BB0C-4ECE-A01E-DDFD359070B7",
    //   LineStatus: { id: 1, name: "Processed" },
    //   DataReceiving: [
    //     {
    //       billetId: "BCA74F13-64AB-4D3B-8575-1D6F0B4D9E21",
    //       billetNumber: "1010201.0056789",
    //       dueDate: new Date("2023-06-15T06:00:00.000Z"),
    //       "delay days": 500,
    //       CollectionType: { id: 2, name: "CreditCard" },
    //       contractId: "4E99A77B-2A1E-49F2-9F16-4FDCA3F1A099",
    //       StatusBillet: {
    //         Billing: { id: 1, name: "Overdue" },
    //         Payment: { id: 1, name: "PartiallyPaid" },
    //       },
    //       InstallmentPlanning: [
    //         {
    //           id: "A17C3D10-8D6B-46DF-9904-2E62C99E1D5F",
    //           controlNegotiationId: "8F5D1234-9F1B-4A59-9DA7-1C5B4E7719E2",
    //           value: 500.0,
    //           Type: { id: 1, name: "Extraordinary" },
    //           accountsReceivableTypeId: "AA77CC88-2B1E-49F2-839A-2FC77960465C",
    //         },
    //       ],
    //       Taxes: {
    //         InterestRate: { percent: 1.5, value: 1.5, interestValue: 45.0 },
    //         LateFees: { percent: 2.5, value: 12.5 },
    //       },
    //     },
    //   ],
    //   DataFile: {
    //     creditDate: new Date("2023-07-10T06:00:00.000Z"),
    //     numberLine: 2,
    //     billetSequential: 9876543,
    //     billetValue: 500.0,
    //     interestValue: 45.0,
    //     lateFeesalue: 12.5,
    //     collectorFeeValue: 30.0,
    //     paidValue: 520.0,
    //     Errors: { type: "Warning", description: ["Partial payment detected"] },
    //   },
    
    // },
    {
      id: "A1B2C3D4-E5F6-4789-ABCD-9876543210FE",
      receivingBatchCollectorId: "F0B8D5B2-E1F7-40AD-A433-364520DB73F0",
      LineStatus: { id: 1, name: "standBy" },
      DataReceiving: [
        {
          billetId: "EFA1356A-9E8D-4C67-B5F2-174BA7C1D4E5",
          billetNumber: "1010201.0098765",
          dueDate: new Date("2024-02-10T06:00:00.000Z"),
          "delay days": 10,
          CollectionType: { id: 3, name: "DirectDebit" },
          contractId: "3B4C5D6E-7F8A-9B0C-DEF1-23456789ABCD",
          StatusBillet: {
            Billing: { id: 2, name: "Cancelled" },
            Payment: { id: 2, name: "Failed" },
          },
          InstallmentPlanning: [
            {
              id: "5F6G7H8I-9J0K-4L5M-6N7O-8P9Q0R1S2T3U",
              controlNegotiationId: "6N7O8P9Q-0R1S-2T3U-4V5W-6X7Y8Z9A0B1C",
              value: 750.0,
              Type: { id: 2, name: "Special" },
              accountsReceivableTypeId: "7Y8Z9A0B-1C2D-3E4F-5G6H-7I8J9K0L1M2N",
            },
          ],
          Taxes: {
            InterestRate: { percent: 2.0, value: 5.0, interestValue: 20.0 },
            LateFees: { percent: 3.0, value: 22.5 },
            Honorario: { percent: 10, value: 50 },
          },
          
        },
      ],
      DataFile: {
        creditDate: new Date("2024-03-01T06:00:00.000Z"),
        numberLine: 15,
        billetSequential: 6543210,
        billetValue: 750.0,
        interestValue: 20.0,
        lateFeesValue: 22.5,
        honorarioValue: 50,
        collectorFeeValue: 35.0,
        paidValue: 0.0,
        beneficiaryName: "Isabel Barja",
        Errors: { type: "Error", description: ["Payment rejected by bank"] },
      },
    },
  ];